import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import CardFront from '../imgs/cardfront.jpg'
import CardBack from '../imgs/cardback.jpg'

const styles = theme => ({
    container: {
    },
    left_bar: {
        width: 200
    },
    content: {
        width: '100%'
    },
    img: {
        width: '100%'
    },
    title: {
        marginTop: 20,
        color: '#393287',
        fontSize: 16
    },
    p: {
        // marginBottom: 20,
        // marginTop: 20,
        color: '#393287',
        fontSize: 16
    },
    details: {
        paddingLeft: 10
    }
})

class Home extends React.Component{
    render(){
        const {classes} = this.props

        return (
            <Grid container>
                <Grid item md={4} sm={12}>
                    <Typography variant="headline" className={classes.title}>
                        Contact
                    </Typography>
                    <Typography variant="title" className={classes.p}>
                        Email: yuanzhe.jane@gmail.com
                    </Typography>
                    <Typography variant="title" className={classes.p}>
                        Phone: 510.552.8079
                    </Typography>
                </Grid>
                <Grid item md={8} sm={12} className={classes.details}>
                    {/* <img src={CardFront} className={classes.img}/> */}
                    <img src={CardBack} className={classes.img}/>
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles)(Home)